/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_User_Link_NoneInputs */

const vi_grower_user_link_none = /** @type {(inputs: Grower_User_Link_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không liên kết`)
};

/**

* @param {Grower_User_Link_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_user_link_none = /** @type {((inputs?: Grower_User_Link_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_User_Link_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_user_link_none(inputs)
});